// extracted by mini-css-extract-plugin
module.exports = {"client-service-and-diagnosis":"styles_client-service-and-diagnosis__w3T5P"};